<template>
  <div class="d-flex align-items-center header-search">
    <div
      v-click-outside="searchFocusOut"
      class="w-100"
    >
      <div class="d-flex justify-content-between">
        <div class="position-relative w-100">
          <div class="header-search-icon position-absolute" />
          <b-form-input
            :title="$t('mit_keresel_title')"
            :placeholder="$t('mit_keresel_title')"
            @update="search"
            debounce="300"
            v-model="searchInputValue"
            @focusin="searchFocusIn"
            @keydown.enter="goToSearchPage"
            ref="searchInput"
            class="header-search-input pl-4"
            type="text"
          />
        </div>
        <div
          v-if="isMobile"
          class="close-icon cursor-pointer ml-2"
          @click="$emit('closeSearch')"
        />
      </div>
      <div v-if="!isMobile">
        <div
          class="autocomplete-suggestions-container"
          v-if="isSearchFocused && ((articlesSearchRes && articlesSearchRes.length > 0) || (productsSearchRes && productsSearchRes.length > 0))"
        >
          <a
            v-t="'kereso_ossz_talalat'"
            class="all_result"
            @click="goToSearchPage"
          />
          <div
            v-for="product in productsSearchRes"
            :key="product.id"
            class="suggestion suggestion-product"
          >
            <router-link :to="product.url" @click.native="storeClickOnProduct(product.id);resetInputAndCloseSearch()">
              <div class="row">
                <div class="col-4 d-flex justify-content-center align-items-center">
                  <img
                    class="img-fluid search-result-img"
                    :src="product.imgSrc"
                    :alt="product.title"
                  >
                </div>
                <div class="col-8">
                  <div class="product-detail-secondary text-uppercase" v-text="product.brand" />
                  <div class="product-detail-primary" v-text="product.title" />
                  <!-- eslint-disable-next-line vue/no-v-html priceban van html... -->
                  <div class="mt-3 product-detail-primary" v-html="product.price" />
                  <div class="product-detail-secondary" v-text="product.unitPriceFormatted" />
                </div>
              </div>
            </router-link>
          </div>
          <div
            v-for="article in articlesSearchRes"
            :key="article.id"
            class="suggestion suggestion-product"
          >
            <router-link :to="article.url" @click.native="storeClickOnArticle(article.id);resetInputAndCloseSearch()">
              <div class="row">
                <div class="col-4 d-flex justify-content-center align-items-center">
                  <img
                    class="img-fluid search-result-img"
                    :src="article.imgSrc"
                    :alt="article.title"
                  >
                </div>
                <div class="col-8">
                  <div class="product-detail-primary" v-text="article.title" />
                  <div class="product-detail-secondary" v-text="article.desc" />
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else class="mobile-search-result-container">
        <b-tabs pills>
          <b-tab
            :title="$t('osszes_termek')"
            active
          >
            <div
              v-if="isSearchInProgress"
              class="d-flex align-items-center justify-content-center h-100 w-100"
            >
              <loading-indicator />
            </div>
            <div
              v-else-if="productsSearchRes.length === 0"
              v-t="'nincs_megjelenitheto_tartalom'"
              class="d-flex align-items-center justify-content-center h-100 w-100"
            />
            <template v-else>
              <div
                v-for="product in productsSearchRes"
                :key="product.id"
                class="suggestion suggestion-product my-2"
              >
                <router-link :to="product.url" @click.native="storeClickOnProduct(product.id);resetInputAndCloseSearch()">
                  <div class="d-flex col-12">
                    <div class="col-4 d-flex justify-content-center align-items-center">
                      <img
                        class="img-fluid search-result-img"
                        :src="product.imgSrc"
                        :alt="product.title"
                      >
                    </div>
                    <div class="col-8">
                      <div class="product-detail-secondary text-uppercase" v-text="product.brand" />
                      <div class="product-detail-primary" v-text="product.title" />
                      <!-- eslint-disable-next-line vue/no-v-html priceban van html... -->
                      <div class="mt-3 product-detail-primary" v-html="product.price" />
                      <div class="product-detail-secondary" v-text="product.unitPriceFormatted" />
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="go-to-all-result-mobile position-absolute py-3 w-100">
                <a
                  v-t="'kereso_ossz_talalat'"
                  class="all_result position-relative"
                  @click="goToSearchPage"
                />
              </div>
            </template>
          </b-tab>
          <b-tab
            :title="$t('menu_shop_prcikkek')"
            lazy
          >
            <div
              v-if="isSearchInProgress"
              class="d-flex align-items-center justify-content-center h-100 w-100"
            >
              <loading-indicator />
            </div>
            <div
              v-else-if="articlesSearchRes.length === 0"
              v-t="'nincs_megjelenitheto_tartalom'"
              class="d-flex align-items-center justify-content-center h-100 w-100"
            />
            <template v-else>
              <div
                v-for="article in articlesSearchRes"
                :key="article.id"
                class="suggestion suggestion-product my-2"
              >
                <router-link :to="article.url" @click.native="storeClickOnArticle(article.id);resetInputAndCloseSearch()">
                  <div class="d-flex col-12">
                    <div class="col-4 d-flex justify-content-center align-items-center">
                      <img
                        class="img-fluid search-result-img"
                        :src="article.imgSrc"
                        :alt="article.title"
                      >
                    </div>
                    <div class="col-8">
                      <div class="product-detail-primary" v-text="article.title" />
                      <div class="product-detail-secondary" v-text="article.desc" />
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="go-to-all-result-mobile position-absolute py-3 w-100">
                <a
                  v-t="'kereso_ossz_talalat'"
                  class="all_result position-relative"
                  @click="goToSearchPage"
                />
              </div>
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { NOTY_TYPE } from '../../constant/builderConsts.js'
import { BFormInput, BTab, BTabs } from 'bootstrap-vue'
import Vue from 'vue'
import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

export default {
  name: 'HeaderSearch',
  components: {
    'loading-indicator': () => import(/* webpackChunkName: "LoadingIndicator" */ '../LoadingIndicator/LoadingIndicator.vue'),
    'b-tabs': BTabs,
    'b-tab': BTab,
    'b-form-input': BFormInput,
  },
  data() {
    return {
      /**
       * keresendő string
       */
      searchInputValue: '',
      /**
       * kereső mező focusban van-e
       */
      isSearchFocused: false,
      /**
       * termék eredmények
       */
      productsSearchRes: [],
      /**
       * cikk eredmények
       */
      articlesSearchRes: [],
      /**
       * keresés fut-e épp
       */
      isSearchInProgress: false,
    }
  },
  computed: {
    /**
     * mobil nézet-e
     *
     * @return {boolean}
     */
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
  },
  created() {
    this.$root.$on('closeSearch', this.searchFocusOut)
  },
  destroyed() {
    this.$root.$off('closeSearch', this.searchFocusOut)
  },
  methods: {
    /**
     * keresés
     */
    search() {
      if (this.searchInputValue.length < 3) {
        this.productsSearchRes = []
        this.articlesSearchRes = []
        return
      }
      this.searchFocusIn()
      this.isSearchInProgress = true
      Axios.get('/Shop/api/quickSearch', {
        params: {
          searchKey: this.searchInputValue,
        },
      })
        .then(({ data }) => {
          this.productsSearchRes = data.productSearchRes
          this.articlesSearchRes = data.articleSearchRes
        })
        .catch((e) => {
          console.error('search', e)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
        .finally(() => {
          this.isSearchInProgress = false
        })
    },
    /**
     * bekattintottunk a keresőből, most kell mutatni
     */
    searchFocusIn() {
      this.isSearchFocused = true
    },
    /**
     * Termékre kattintás eltárolása az adatbázisban
     * @param productId
     */
    storeClickOnProduct(productId) {
      Axios.post('/Shop/api/storeClickOnSearchedItem', {
        clickWhat: 'product',
        clickId: productId,
      })
    },
    /**
     * Cikkre kattintás eltárolása az adatbázisban
     * @param articleId
     */
    storeClickOnArticle(articleId) {
      Axios.post('/Shop/api/storeClickOnSearchedItem', {
        clickWhat: 'article',
        clickId: articleId,
      })
    },
    resetInputAndCloseSearch() {
      this.searchInputValue = ''
      this.articlesSearchRes = []
      this.productsSearchRes = []
      this.$emit('closeSearch')
    },
    /**
     * kereső oldalra navigálás
     */
    goToSearchPage() {
      if (this.searchInputValue.length < 3) {
        return
      }
      if (this.$router.currentRoute.path !== '/search') {
        this.$router.push('/search?searchKey=' + this.searchInputValue)
      } else if (this.$router.currentRoute.fullPath !== '/search?searchKey=' + this.searchInputValue) {
        this.$router.replace('/search?searchKey=' + this.searchInputValue)
        this.$root.$emit('doSearch', this.searchInputValue)
      }
      this.resetInputAndCloseSearch()
      this.searchFocusOut()
    },
    /**
     * kikattintottunk a keresőből, nem kell tovább mutatni
     */
    searchFocusOut() {
      if (this.isSearchFocused === false) {
        return
      }
      this.isSearchFocused = false
      if (this.isMobile) {
        this.$emit('closeSearch')
      }
    },
  },
}
</script>

<style lang="scss" scoped src="./header-search.scss" />
